import React from "react";
import { DatePickerInputNew } from "../../Helpers/Input/Input";
import { formatDateForAPI } from "../../../utils";

export default function POIsWorkloadHeader({ setStartDate, setEndDate }) {
	return (
		<div className="bg-white p-16 d-flex align-items-baseline gap-3">
			<DatePickerInputNew
				id="dateRange"
				name="dateRange"
				onChange={({ startDate, endDate }) => {
					setStartDate(formatDateForAPI(startDate));
					if (endDate) {
						const end = new Date(endDate.valueOf());
						end.setHours(23, 59, 59, 0);
						setEndDate(formatDateForAPI(end));
					}
				}}

				//startDate={values?.startDate || null}
				//endDate={values?.endDate || null}
			/>
		</div>
	);
}
